import { useState } from 'react';

import { useOnCurrentTimeChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentTimeChanged';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

export const useCurrentTime = (delay = 1) => {
    const instance = usePlayerInstance();
    const [currentTime, setCurrentTime] = useState<number>(() => instance?.currentTime || 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useOnCurrentTimeChanged(setCurrentTime, delay);

    return currentTime;
};
